<template>
  <span>
    <!-- Dialog para análise de solicitações de cancelamento de notas fiscais -->
    <Dialog class="test-box" 
      :visible.sync="showAnaliseCancelarNota" :modal="true" :closable="false">
      <h1 class="titulo-header">
        {{textoHeader}}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text" @click="showAnaliseCancelarNota = false"/>
      </h1><br/>
      <div  v-if="notaFiscalSituacao">

        <div id="topo" class="row">
          <div class="col-md-5 mb-2">
            <label for="num">Número: </label>
            <span class="p-fluid">
              <InputText v-model="nota.numero" disabled="true" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            <label for="desc">Descrição Solicitação de {{ tipo }}: </label>
            <span class="p-fluid">
              <textarea v-model="notaFiscalSituacao.observacao" rows="5" disabled="true" />
            </span>
          </div>
        </div>

      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="deferir()" href="#topo" type="button" label="Deferir"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />

            <Button @click="indeferir()" href="#topo" type="button" label="Indeferir" class="p-button-primary mr-2"
              icon="pi pi-times" :disabled="loading" />
          </div>

          <div>
            <Button @click="showAnaliseCancelarNota = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import LoginService from "@/services/acesso/login.service";

export default {
  name: "AnaliseCancelamentoNotaFiscal",

  created() {
    this.currentUser = LoginService.currentUserValue;

    this.$root.$on("notaFiscal:analiseCancelamento", (dadosNotaFiscal) => {
      this.nota = dadosNotaFiscal.nota;
      this.notaFiscalSituacao = dadosNotaFiscal.notaSituacao;
      this.tipo = (this.notaFiscalSituacao.idSituacaoRecolhimento && this.notaFiscalSituacao.idSituacaoRecolhimento === 'SA' ? 'Substituição' : 'Cancelamento');
      this.textoHeader = "Análise Solicitação de "+this.tipo+" Nota Fiscal";

      this.exibirDialogAnaliseCancelarNota(true);

    });
  },

  data() {
    return {
      tipo:"",
      textoHeader:"",
      currentUser: null,
      nota: null,
      notaFiscalSituacao: null,
      showAnaliseCancelarNota: false
    };
  },

  methods: {
    // Exibe o dialog de análise
    exibirDialogAnaliseCancelarNota(showAnaliseCancelarNota) {
      this.showAnaliseCancelarNota = showAnaliseCancelarNota;
    },
    // Defere a solicitação de cancelamento
    deferir() {
      this.$parent.processando(true);
      NotaFiscalService.definirAnaliseCancelamentoNotaFiscal(this.nota.id, this.notaFiscalSituacao.id, 'D')
        .then((response) => {
          this.$root.$emit(
            "alert:info",
            response.data
          );

        },
          (error) => {
            const erro = error.response.data;

            if (erro) {
              this.$root.$emit(
                "alert:warn",
                erro
              );
            }
          })
        .then(() => {
          this.$parent.processando(false);
          this.exibirDialogAnaliseCancelarNota(false);
        });
    },
    // Indefere a solicitação de cancelamento
    indeferir() {
      this.$parent.processando(true);
      NotaFiscalService.definirAnaliseCancelamentoNotaFiscal(this.nota.id, this.notaFiscalSituacao.id, 'I')
        .then((response) => {
          this.$root.$emit(
            "alert:info",
            response.data
          );
          if (this.$parent.$options.name == "ConsultaNfse") {
            this.$parent.pesquisar();
          }

        },
          (error) => {
            const erro = error.response.data;

            if (erro) {
              this.$root.$emit(
                "alert:warn",
                erro
              );
            }
          })
        .then(() => {
          this.$parent.processando(false);
        });
    }
  },

  computed: {
    loading() {
      return this.$parent.loading;
    }
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 12px;
}

.mensagem-cancelamento {
  color: red;
  font-weight: bold;
}
</style>